module.exports = __webpack_public_path__ + "img/tree-01-c-trunk.edf4807e.png";